export class Location {
    id: string = '';
    restaurantName: string = '';
    streetAddress: string = '';
    city: string = '';
    stateAbbr: string = '';
    zipCode: string = '';
}